export default {"src":"/_next/static/media/checklist.2c21ea31.svg","height":72,"width":72};